import { TTasksFilters } from "@/types";

export const DEFAULT_TASKS_FILTERS: TTasksFilters = {
	projectId: undefined,
	viewId: undefined,
	page: 1,
	limit: 30,
	sortType: "desc",
	dateFrom: undefined,
	dateTo: undefined,
};

/** The `:taskId` segment of the home URL that opens the new-task form. */
export const NEW_TASK = "new";
